import { render, staticRenderFns } from "./PencilRuleIcon.vue?vue&type=template&id=22b2b4cf&"
import script from "./PencilRuleIcon.vue?vue&type=script&lang=ts&"
export * from "./PencilRuleIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports